import { render, staticRenderFns } from "./stepInformationBarEN101.vue?vue&type=template&id=007b491f&scoped=true"
import script from "./stepInformationBarEN101.vue?vue&type=script&lang=js"
export * from "./stepInformationBarEN101.vue?vue&type=script&lang=js"
import style0 from "./stepInformationBarEN101.vue?vue&type=style&index=0&id=007b491f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007b491f",
  null
  
)

export default component.exports